import { FC, useEffect, useState } from "react";
import { API } from "../../api";
import { StepType } from "../../types";

interface ComplaintProps {
  article_id: string;
  step_id: number;
  setType?: (type: StepType) => void;
  close: () => void;
}

export const UnclearBlock: FC<ComplaintProps> = ({ article_id, step_id, setType, close }) => {
  const [text, setText] = useState("");
  const [email, setEmail] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [error, setError] = useState("");

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked);
  };

  const submitHandler = async () => {
    if (text.length > 5) {
      await API.addComplaint(article_id, step_id, text, email);
      close()
      // setType && setType("gratitude");
    } else {
      setError("Напишите, пожалуйста, более подробно.");
    }
  };

  const backHandler = () => {
    setType && setType("step");
  };

  useEffect(() => {
    API.addUnclear(article_id, step_id);
  }, []);

  return (
    <div className="card">
      <h3>🤨 Очень жаль</h3>
      <div className="text">
      Пожалуйста, сообщите, если что-то осталось непонятным или не соответствует действительности. Мы внесем необходимые изменения в инструкцию или продукт.
      </div>
      <textarea
        className="textarea"
        placeholder="Пожалуйста, напишите в произвольной форме. Ваши ответы анонимны."
        rows={8}
        onChange={(e) => setText(e.target.value)}
        autoFocus
      />
      {error && <div style={{ color: "red", marginTop: '20px' }}>{error}</div>}

      {/* <div className="margin">
        <input
          type="checkbox"
          className="checkbox"
          checked={isChecked}
          id="myCheckbox"
          onChange={handleCheckboxChange}
        />
        <label htmlFor="myCheckbox">Хочу получить ответ на почту</label>
      </div>
      {isChecked && (
        <input
          placeholder="Куда отправить ответ"
          className="input margin"
          onChange={(e) => setEmail(e.target.value)}
        />
      )} */}

      <div className="buttons">
        <button className="success" onClick={submitHandler}>
          Отправить
        </button>
        {setType && (
          <button className="unclear" onClick={backHandler}>
            Назад
          </button>
        )}
        {close && (
          <button className="unclear" onClick={close}>
            Закрыть
          </button>
        )}
      </div>
    </div>
  );
};
